import { componentClasses } from "../../../core/components/file-input/file-input";
import { closeX } from "../../../core/js/helpers/built-in-icons";
import { classes, deepMerge, formatToBytes } from "../../../core/js/utilities";
import { iconTemplate } from "../icon/icon.template";
import { randomNumGenerator, toKebabCase } from "../../../core/js/utilities";

const defaultProps = {
    size: "",
    name: "",
    state: "",
};

export const fileInputItemTemplate = (props = defaultProps) => {
    // The File object is read-only.  So have to make a clone of the props it provides that we want to use,
    // Then we can merge this with the defaultProps.
    const cloneProps = { name: props.name, size: props.size, state: props.state };

    const mergedProps = deepMerge(defaultProps, cloneProps);

    // Convert the size to a readable format
    const formattedSize = formatToBytes(mergedProps.size);

    const componentKey = randomNumGenerator();
    const _componentName = toKebabCase("FileItem");
    const contentId = mergedProps.contentId || `${_componentName}-content-${componentKey}`;
    const feedbackId = mergedProps.feedbackId || `${_componentName}-feedback-${componentKey}`;
    const nameId = mergedProps.nameId || `${_componentName}-name-${componentKey}`;

    const itemClasses = classes({
        [componentClasses.item.base]: true,
        [componentClasses.item[mergedProps.state]]: componentClasses.item[mergedProps.state]
            ? true
            : false,
    });

    const name = mergedProps.name ? nameTemplate({ id: nameId, children: mergedProps.name }) : "";
    const size = mergedProps.size ? sizeTemplate({ id: nameId, children: formattedSize }) : "";

    return `
<li class="${itemClasses}">
    <span class="${componentClasses.item.text}">
        <span class="${componentClasses.item.content}" id="${contentId}">
            ${name}
            ${size}
        </span>
        <div class="${
            componentClasses.item.feedback
        }" aria-live="polite" id="${feedbackId}">${buildFeedbackTemplate(mergedProps.state)}</div>
    </span>
    <button class="${
        componentClasses.item.close
    }" aria-label="Remove file button">${closeX()}</button>
</li>`;
};

const buildFeedbackTemplate = (state) => {
    const string = state;
    let insert;
    switch (string) {
        case "rest":
            break;
        case "uploading":
            insert = `<div class="dds__loading-indicator dds__loading-indicator--sm dds__icon dds__file-input__item__feedback__icon">
                <div class="dds__loading-indicator__spinner"></div>
                </div>
                Uploading`;
            break;
        case "success":
            insert = ` ${iconTemplate({
                type: "svg",
                name: "alert-check-cir",
                additionalClasses: [`${componentClasses.item.feedbackIcon}`],
            })}
                <strong>Success:</strong>&nbsp;File ready to submit`;
            break;
        case "error":
            insert = ` ${iconTemplate({
                type: "svg",
                name: "alert-notice",
                additionalClasses: [`${componentClasses.item.feedbackIcon}`],
            })}
                <strong>Error:</strong>&nbsp;Exceeded maximum number of selectable files`;
            break;
        default:
            insert = "";
    }

    return insert;
};

const nameTemplate = ({ id, children }) => {
    return ` <span class="dds__file-input__item__name" id="${id}">${children}</span>`;
};

const sizeTemplate = ({ children }) => {
    return ` <span class="dds__file-input__item__size">${children}</span>`;
};
